import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import Log from '../../assets/images/logout1.png';
import Log1 from '../../assets/images/logout2.png';

const InvoiceModal = ({ showModal, invoiceData, onClose }) => {
    const { services, totalPrice } = invoiceData;

    const handlePrint = () => {
        window.print(); // Imprimer la page
    };

    return (
        <Modal show={showModal} onHide={onClose} size="xl" scrollable>
            <Modal.Header closeButton>
                <Modal.Title className="text-center">Facture de Consultation</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflowY: 'auto', textAlign: 'center' }}>
                <table className="table table-bordered" style={{ margin: '0 auto', width: '80%' }}>
                    <thead>
                        <tr>
                            <th className="text-center">Service</th>
                            <th className="text-center">Prix Unitaire</th>
                            <th className="text-center">Quantité</th>
                            <th className="text-center">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {services.map((service, index) => (
                            <tr key={index}>
                                <td>{service.name}</td>
                                <td>{service.price} XOF</td>
                                <td>{service.quantity}</td>
                                <td>{service.total} XOF</td>
                            </tr>
                        ))}
                        <tr className="table table-bordered">
                            <td colSpan="3" className="text-center">Total</td>
                            <td>{totalPrice} XOF</td>
                        </tr>
                    </tbody>
                </table>

                <div className="d-flex justify-content-center gap-4 mt-4">
                    <Button
                        variant="secondary"
                        onClick={onClose}
                        className="d-flex align-items-center px-4 py-2 shadow"
                        style={{ background: '#1A5D1A' }}
                    >
                        Fermer <img src={Log} className='ms-2' alt="Go back" />
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handlePrint}
                        className="d-flex align-items-center px-4 py-2 shadow"
                    >
                        Imprimer <img src={Log1} className='ms-2' alt="Save" />
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default InvoiceModal;
